import { settings as AudioLength } from "./book/AudioLength";
import { settings as ContentWarnings } from "./book/ContentWarnings";
import { settings as Details } from "./book/Details";
import { settings as Genres } from "./book/Genres";
import { settings as Moods } from "./book/Moods";
import { settings as Length } from "./book/Length";
import { settings as Pages } from "./book/Pages";
import { settings as Rating } from "./book/Rating";
import { settings as ReadersCount } from "./book/ReadersCount";
import { settings as ReleaseDate } from "./book/ReleaseDate";
import { settings as ReleaseYear } from "./book/ReleaseYear";
import { settings as UsersCount } from "./book/UsersCount";

import { settings as DataCount } from "./data/DataCount";

import { settings as OwnerDatesRead } from "./owner/OwnerDatesRead";
import { settings as OwnerDetails } from "./book/OwnerDetails";
import { settings as OwnerRating } from "./owner/OwnerRating";

import { settings as UserBookReadDetails } from "./book/UserBookReadDetails/UserBookReadDetails";

import { settings as GoalPosition } from "./goal/position";

import { settings as PromptVote } from "./prompt/vote";
import { settings as PromptPosition } from "./prompt/position";

import { settings as BookButton } from "./user/BookButton";
import { settings as Match } from "./user/Match";
import { settings as CurrentUserRating } from "./user/CurrentUserRating";

import { settings as ListPosition } from "./list/position";

import { settings as SeriesPosition } from "./series/position";
import { settings as SeriesDetails } from "./series/details";

export default {
  AudioLength,
  ContentWarnings,
  Details,
  Genres,
  Moods,
  Length,
  Pages,
  Rating,
  ReadersCount,
  ReleaseDate,
  ReleaseYear,
  UsersCount,

  // Data
  DataCount,

  // Owner
  OwnerDatesRead,
  OwnerDetails,
  OwnerRating,
  UserBookReadDetails,

  // User
  BookButton,
  CurrentUserRating,
  Match,

  // List
  ListPosition,

  // Goal
  GoalPosition,

  // Prompt
  PromptVote,
  PromptPosition,

  // Series
  SeriesPosition,
  SeriesDetails,
};
